import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import { Form, Input } from 'antd';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

import { React, useState } from 'react';

const LinkWorkItems = ({ isOpen, onClose }) => {
  const [linkType, setLinkType] = useState(null);
  const [inwardlinkdescription, setInwardLinkDescription] = useState(null);
  const [outwardlinkdescription, setOutwardlinkDescription]=useState(null);
  

   const handleAddWorkLinkItems = async () => {
    try {
      const payload = {
        link_type_name: linkType,
        outward_label: outwardlinkdescription,
        inward_label: inwardlinkdescription,
      };

      const response = await httpInjectorService.createLinkType(payload);
      if(response.status==="sucess"){

      }

      
    } catch (error) {
      console.error(error);
      
    }
  };


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>Add a new link type</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <div>
            <Form
              layout="horizontal"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16, offset: 1 }}
            >
              <Form.Item
                label="Link type"
                rules={[
                  { required: true, message: 'Please enter the Link type' },
                ]}
                extra='(eg "Duplicate")'
              >
                <Input
                  value={linkType}
                  onChange={(e) => setLinkType(e.target.value)}
                  placeholder="Enter Link type"
                />
              </Form.Item>

              <Form.Item
                label="Outward Link Description"
                rules={[
                  { required: true, message: 'Please enter the description' },
                ]}
                extra='(eg "duplicates")'
              >
                <Input
                  value={outwardlinkdescription}
                  onChange={(e) => setOutwardlinkDescription(e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Item>

              <Form.Item
                label="Inward Link Description"
                rules={[
                  { required: true, message: 'Please enter the description' },
                ]}
                extra='(eg "is duplicated by")'
              >
                <Input
                  value={inwardlinkdescription}
                  onChange={(e) => setInwardLinkDescription(e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Item>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>

          <Button
            bg="#884B9E"
            color="white"
            _hover={{ bg: '#6f3a80' }}
            onClick={() => {
              handleAddWorkLinkItems();
              onClose();
            }}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LinkWorkItems;
